import { X, FileText, Image } from 'lucide-react';
import { CopyVariant, Visual } from '../../consultantTypes';

interface PreviewModalProps {
  copyVariants: CopyVariant[];
  visuals: Visual[];
  onClose: () => void;
  onConfirm: () => void;
}

export function PreviewModal({ copyVariants, visuals, onClose, onConfirm }: PreviewModalProps) {
  const selectedCopy = copyVariants.filter(c => c.selected);
  const selectedVisuals = visuals.filter(v => v.selected);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-hidden">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Preview Pakket</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto max-h-[calc(90vh-180px)]">
          <p className="text-gray-700 mb-6">
            Dit pakket wordt gedeeld met de klant voor review. Controleer alle content voordat je deelt.
          </p>

          <div className="space-y-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <FileText className="w-5 h-5 text-blue-600" />
                <h3 className="font-semibold text-gray-900">
                  Geselecteerde Teksten ({selectedCopy.length})
                </h3>
              </div>
              <div className="space-y-4">
                {selectedCopy.map((copy, index) => (
                  <div key={copy.id} className="bg-gray-50 rounded-lg p-4">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="inline-flex items-center justify-center w-6 h-6 bg-blue-600 text-white text-xs font-bold rounded-full">
                        {index + 1}
                      </span>
                      <h4 className="font-medium text-gray-900">{copy.title}</h4>
                    </div>
                    <p className="text-sm text-gray-700 leading-relaxed whitespace-pre-wrap">
                      {copy.body}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <div className="flex items-center gap-2 mb-4">
                <Image className="w-5 h-5 text-green-600" />
                <h3 className="font-semibold text-gray-900">
                  Geselecteerde Visuals ({selectedVisuals.length})
                </h3>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {selectedVisuals.map((visual, index) => (
                  <div key={visual.id} className="relative">
                    <div className="aspect-video bg-gray-100 rounded-lg overflow-hidden">
                      <img
                        src={visual.url}
                        alt={visual.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="mt-2">
                      <span className="inline-flex items-center justify-center w-5 h-5 bg-green-600 text-white text-xs font-bold rounded-full mr-2">
                        {index + 1}
                      </span>
                      <span className="text-sm text-gray-700">{visual.title}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 p-6 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg font-medium text-gray-700 hover:bg-gray-100 transition-colors"
          >
            Annuleren
          </button>
          <button
            onClick={onConfirm}
            className="px-6 py-2 rounded-lg font-medium bg-blue-600 text-white hover:bg-blue-700 transition-colors"
          >
            Bevestig & Deel
          </button>
        </div>
      </div>
    </div>
  );
}
